import * as React from 'react'
import { styled } from 'next-yak'
import { BREAKPOINTS } from '@ulule/owl-kit-components/next'

import { useLilSam, Rule, Project } from './useLilSam'

type LilSamProps<PROJECT extends Project> = {
  className?: string
  namespace: string
  project: PROJECT
  rule: { body: Rule; dependencies: any[] }
  updateSteps: (onboarding_steps: any) => Promise<any>
}

const FixedWrapper = styled.div`
  position: absolute;
  top: 120px;
  left: 10px;

  @media screen and ${BREAKPOINTS.TABLET} {
    top: 74px;
    left: 230px;
  }
`

function LilSamComponent<PROJECT extends Project>({
  className,
  namespace,
  project,
  rule,
  updateSteps,
}: LilSamProps<PROJECT>): React.ReactElement<LilSamProps<PROJECT>> | null {
  const lilSam = useLilSam(namespace, project, rule.body, rule.dependencies, updateSteps)

  return <FixedWrapper className={className}>{lilSam}</FixedWrapper>
}

export const LilSam = styled(LilSamComponent)``
